import { useEffect, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function MeLeave() {
  const [reqs, setReqs] = useState([]);
  const [form, setForm] = useState({ type:"annual", start_date:"", end_date:"", reason:"" });

  const load = () => api.get("/hr/leave/mine").then(r=>setReqs(r.data)).catch(()=>setReqs([]));
  useEffect(() => { load(); }, []);

  const submit = async () => {
    if (!form.start_date || !form.end_date) return toast.error("Pick both dates");
    try {
      await api.post("/hr/leave", form);
      toast.success("Request submitted — waiting for approval");
      setForm({ type:"annual", start_date:"", end_date:"", reason:"" });
      load();
    } catch(e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="space-y-4" data-testid="me-leave">
      <div>
        <div className="text-xs uppercase tracking-widest text-neutral-500">Time &amp; Leave</div>
        <h1 className="text-3xl font-bold font-display mt-1">Request time off</h1>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <Card className="border-0 shadow-sm">
          <CardContent className="p-6 space-y-3">
            <h3 className="font-semibold mb-1">New request</h3>
            <div>
              <Label className="text-xs">Type</Label>
              <select className="w-full px-3 py-2 text-sm rounded-lg border border-neutral-200" value={form.type} onChange={e=>setForm({...form, type:e.target.value})} data-testid="leave-type">
                <option value="annual">Annual leave</option>
                <option value="sick">Sick leave</option>
                <option value="unpaid">Unpaid</option>
                <option value="parental">Parental</option>
              </select>
            </div>
            <div className="grid grid-cols-2 gap-2">
              <div><Label className="text-xs">Start</Label><Input type="date" value={form.start_date} onChange={e=>setForm({...form, start_date:e.target.value})} data-testid="leave-start" /></div>
              <div><Label className="text-xs">End</Label><Input type="date" value={form.end_date} onChange={e=>setForm({...form, end_date:e.target.value})} data-testid="leave-end" /></div>
            </div>
            <div><Label className="text-xs">Reason (optional)</Label><Textarea rows={2} value={form.reason} onChange={e=>setForm({...form, reason:e.target.value})} placeholder="Family holiday, medical appointment, etc." /></div>
            <Button onClick={submit} className="btn-primary rounded-full w-full" data-testid="leave-submit">Submit request</Button>
          </CardContent>
        </Card>
        <Card className="border-0 shadow-sm">
          <CardContent className="p-6">
            <h3 className="font-semibold mb-3">Your requests</h3>
            <div className="space-y-2">
              {reqs.length === 0 && <div className="text-sm text-neutral-500">Nothing submitted yet.</div>}
              {reqs.map(r => (
                <div key={r.req_id} className="p-3 rounded-lg bg-neutral-50 flex items-center justify-between" data-testid={`me-leave-${r.req_id}`}>
                  <div>
                    <div className="text-sm font-semibold capitalize">{r.type} — {r.days} day(s)</div>
                    <div className="text-xs text-neutral-500 mt-0.5">{r.start_date} → {r.end_date}</div>
                  </div>
                  <Badge variant="outline" className={
                    r.status==="APPROVED"?"bg-teal/10 text-teal border-teal/20":
                    r.status==="REJECTED"?"bg-red-50 text-red-500 border-red-200":
                    "bg-neutral-100 text-neutral-500"
                  }>{r.status}</Badge>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
